import type {
  PraxaDesktopConnectedWorkItem,
  PraxaDesktopConnectedWorkProvider,
} from "@praxa/platform-contracts";

import type { PraxaConnectedWorkSection } from "./components/praxa/PraxaConnectedWorkPresentation";

const CONNECTED_WORK_ITEM_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu;

export interface PraxaConnectedWorkSearch {
  readonly item?: string;
}

export interface PraxaConnectedWorkItemRouteState {
  readonly provider: PraxaDesktopConnectedWorkProvider;
  readonly query: string;
  readonly section: PraxaConnectedWorkSection;
}

export function parsePraxaConnectedWorkSearch(
  search: Record<string, unknown>,
): PraxaConnectedWorkSearch {
  const item = typeof search.item === "string" ? search.item.trim() : "";
  return CONNECTED_WORK_ITEM_ID_PATTERN.test(item) ? { item: item.toLocaleLowerCase() } : {};
}

export function connectedWorkRouteStateForItem(
  item: PraxaDesktopConnectedWorkItem,
): PraxaConnectedWorkItemRouteState {
  if (item.signals.inbox) return { provider: item.provider, query: "", section: "inbox" };
  if (item.signals.myWork) return { provider: item.provider, query: "", section: "my_work" };
  if (item.signals.docs) return { provider: item.provider, query: "", section: "docs" };
  if (item.signals.activity) return { provider: item.provider, query: "", section: "activity" };
  if (item.pinned) return { provider: item.provider, query: "", section: "pinned" };
  return { provider: item.provider, query: item.title, section: "search" };
}
